<template>
<div id="print-editor">

<component :is="`style`" >
    {{ configurationStyle }}
</component>


<b-container fluid>
<b-row>
    <b-col lg="10">
        <div v-if="!Array.isArray(stopTimetables) || stopTimetables.length == 0" class="page" :size="pageSize" :orientation="pageOrientation">
            <div :class="printableTimetableClass">
                    <div class="header" v-if="header" ref="header">
                        <div class="header-content" ref="headerContent" :style="'font-size: '+ dynamicFontSizes['header-template']+'px;'" data-id='header-template'>
                            <div class="stop-name">Pysakki</div>
                            <div class="stop-line"><span class="line-label">0</span>Linjan nimi</div>
                            <!--<div class="info">{{ pageInfo }}</div>-->
                            <table class="info-table">
                            <tr>
                                <td class="additional-info">{{ pageInfo }}</td>
                                <td>
                                </td>
                            </tr>
                            </table>
                        </div>
                    </div>
                    <div ref="tableContainer" class="timetable">
                        <table ref="stopTimetable" class="stop-timetable" :style="'font-size: '+ dynamicFontSizes['timetable-template'] +'px;'" data-id='timetable-template'>
                            <tr class="days"><td>&nbsp;</td><td>ma-pe</td><td>la</td><td>su</td></tr>
                            <tr class="times"><td>tunnit</td><td colspan="3">minuutit</td></tr>
                            <tr><td>6</td><td>00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                            <tr><td>7</td><td>00</td><td>00</td><td>00</td></tr>
                            <tr><td>8</td><td>00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                            <tr><td>9</td><td>00</td><td>00</td><td>00</td></tr>
                            <tr><td>10</td><td>00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                            <tr><td>11</td><td>00</td><td>00</td><td>00</td></tr>
                            <tr><td>12</td><td>00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                            <tr><td>13</td><td>00</td><td>00</td><td>00</td></tr>
                            <tr><td>14</td><td>00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                            <tr><td>15</td><td>00</td><td>00</td><td>00</td></tr>
                            <tr><td>16</td><td>00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                            <tr><td>17</td><td>00</td><td>00</td><td>00</td></tr>
                            <tr><td>18</td><td>00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                            <tr><td>19</td><td>00</td><td>00</td><td>00</td></tr>
                            <tr><td>20</td><td>00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                            <tr><td>21</td><td>00</td><td>00</td><td>00</td></tr>
                            <tr><td>22</td><td>00</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                        </table>
                    </div>

                    <div class="footer" v-if="footer">
                        <div class="logo-1"></div>
                        <div class="logo-2"></div>
                    </div>
            </div>
        </div>
        <!-- Yläpuolinen div näkyviin jos yhtään pysäkkiä ei ole valittuna, ts. pysäkkiaikataululista on tyhjä. -->
        <!-- Tämä div v-for -looppina, jonka lähde on lista pysäkkikohtaisia aikataulu-JSONeja. -->
        <div id="print-content" v-else>
            <div v-for="stopTimetable in stopTimetables" :key="'timetable-'+stopTimetable.stop.id"
                :id="stopTimetable.stop.id" class="page" :size="pageSize" :orientation="pageOrientation">
                <div :class="printableTimetableClass">
                        <div class="header" v-if="header" ref="header" >
                            <div class="header-content" ref="headerContent" :style="'font-size: '+ dynamicFontSizes['header-'+stopTimetable.stop.id] +'px;'" :data-id="'header-'+stopTimetable.stop.id">
                                <div class="stop-name">{{ stopTimetable.stop.name }}</div>
                                <table class="line-table">
                                    <tr v-for="row in headerLineRows(stopTimetable.lines)" :key="'linetable-'+row[0].id">
                                        <td v-for="line in row" :key="line.label">
                                            <span class="line-label">{{ line.label }}</span>{{ line.name }}
                                        </td>   
                                    </tr>
                                </table>
                                <table class="info-table">
                                    <tr>
                                        <td class="additional-info">{{ pageInfo }}</td>
                                        <td>
                                            <span v-for="printDaytype in stopTimetable.printDaytypes" :key="'pdt-'+printDaytype.id">
                                                <span class="infocode">{{ printDaytype.infoCode }}</span>=<span class="infotext">{{ printDaytype.info }}</span>
                                            </span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div ref="tableContainer" class="timetable">
                            <table ref="stopTimetable" :class="'stop-timetable daytype-cols-'+stopTimetable.timetableDays.length" :style="'font-size: '+ dynamicFontSizes['timetable-'+stopTimetable.stop.id] +'px;'" :data-id="'timetable-'+stopTimetable.stop.id">
                                <tr class="days">
                                    <td>&nbsp;</td>
                                    <td v-for="days in stopTimetable.timetableDays" :key="stopTimetable.stop.id+'-'+days">{{ days }}</td>
                                </tr>
                                <tr class="times">
                                    <td>{{ $t('print_editor.hours') }}</td>
                                    <td :colspan="stopTimetable.timetableDays.length">{{ $t('print_editor.minutes') }}</td>
                                </tr>
                                <tr v-for="hour in stopTimetable.hours" :key="stopTimetable.stop.id+'-'+hour"
                                class="hhmm"><td>{{ getPaddedHour(hour) }}</td>
                                    <td v-for="days in stopTimetable.timetableDays" :key="stopTimetable.stop.id+'-'+hour+'-'+days">
                                        <div class="departure" v-for="departure in stopTimetable.timetableDepartures[days+'|'+hour]"
                                        :key="stopTimetable.stop.id+'-'+hour+'-'+days+'-'+departure.minutes+'-'+departure.lineLabel">
                                            <span class="time">{{ departure.minutes }}</span>
                                            <span class="infoCode">{{ departure.infoCode }}</span>
                                            <span v-if="stopTimetable.lines.length > 1" class="line">{{ departure.lineLabel }}</span>
                                        </div>
                                    </td>
                                </tr>
                            </table> 
                        </div>
                        <div class="footer" v-if="footer">
                            <div class="logo-1"></div>
                            <div class="logo-2"></div>
                        </div>
                </div>
            </div>
        </div>
    </b-col>

    <!--
    <b-col lg="2">
        <card> -->
            <div id="controls">
                <SelectList :label="$t('print_editor.configuration')" :options="configurationOptions" :value="1" @select="onSelectConfiguration" :disabled = "loading"/> 
                <SelectList :label="$t('print_editor.size')" :options="sizeOptions" value="A4" @select="onSelectSize" :disabled = "loading"/> 
                <SelectList :label="$t('print_editor.orientation')" :options="orientationOptions" value="landscape" @select="onSelectOrientation" :disabled = "loading"/> 

                <label>{{ $t('print_editor.elements.h') }}</label>
                <div>
                    <input v-model="header" type="checkbox" :disabled = "loading"> {{ $t('print_editor.elements.header') }} &nbsp;
                    <input v-model="footer" type="checkbox" :disabled = "loading"> {{ $t('print_editor.elements.footer') }}
                </div>
               
                <label>{{ $t('print_editor.info') }}</label>
                <div><input v-model="pageInfo" type="text" :disabled = "loading"></div>
             
                <hr>
                <SelectList :label="$t('print_editor.stop')" :options="stopOptions" @select="onSelectStop" :searchable="true" :clearable="true" :disabled = "loading" /> 

                <ul id="stop-list-ul">
                    <li v-for="stopTimetable in stopTimetables" :key="stopTimetable.stop.id"
                    @click="removeStop(stopTimetable.stop.id)">{{ stopTimetable.stop.id }} - {{ stopTimetable.stop.name }}<span>x</span>
                    </li>
                </ul>
               
               <RequestInfo :loader="loading" />
              <!-- <hr> -->
               <div class='text-center'>
                <b-button class="btn-success btn-print" @click="print()" :disabled = "configuration == null || stopTimetables.length ==  0 || loading">
                    <b-icon icon="printer" scale="1.2"></b-icon>
                    {{ $t('print_editor.print') }}
                </b-button>
                </div>

            </div>
    <!--
        </card>
    </b-col>
-->
     
 
</b-row>
</b-container>
</div>
</template>

<script>
import printEditor from '@/store/timetable/printEditor'
import vSelect from 'vue-select'

export default {
    components: {
        vSelect
    },
    name: 'PrintEditor',
    data: function() {
        return {
            configuration: null,
            stop: null,
            pageSize: 'A4',
            pageOrientation: 'landscape',
            pageInfo: 'Voimassa xx.xx.xxxx asti',
            header: true,
            footer: true,
            sizeOptions: [
                { id: 'A3', label: 'A3' },
                { id: 'A4', label: 'A4' },
                { id: 'A5', label: 'A5' }  
            ],
            orientationOptions: [
                { id: 'landscape', label: 'Vaaka' },
                { id: 'portrait', label: 'Pysty' }
            ],
            dynamicFontSizes : {},
            loading: false
        };
    },
    computed: {
        printConfigurations() {
            return this.$store.state.printEditor.configurationList;
        },
        configurationOptions(){
            var optionList = [];
            
            for (var item of this.printConfigurations) {
                optionList.push({ id: item.id, label: item.name })
            }
            
            return optionList;
        },

        stopOptions() {
            var options = [];
            for (let stop of this.$store.state.printEditor.stopList) {
                options.push({ id: stop.id, label: stop.id +' - '+ stop.name });
            }
            return options;
        },
        logoList() {
            return this.$store.state.printEditor.logoList;
        },
        stopTimetables() {
            return this.$store.state.printEditor.stopTimetables;
        },
        footerStyle() {
            var style = 'background-image: ';
            var list = this.$store.state.printEditor.logoList;
            if (Array.isArray(list) && list.length > 0) {
                for (let logoData of list) {
                    if (style.length > 18) style += ', ';
                    style += 'url("' + logoData.imgData + '")';
                }
            }
            return style + ';';
        },
        printableTimetableClass() {
            var clas = 'printable-timetable';
            if (!this.header)
                clas += ' no-header';
            if (!this.footer)
                clas += ' no-footer';
            return clas;
        },
        configurationStyle(){
            return (this.configuration && this.configuration.style) ? this.configuration.style : "";
        },
        configurationText(){
            return (this.configuration && this.configuration.text) ? this.configuration.text : "";
        },

    },
    watch: {
        stop() {
            this.fitAllPageContents();
        },
        pageSize() {
            this.fitAllPageContents();
        },
        pageOrientation() {
            this.fitAllPageContents();
        },
        header() {
            this.fitAllPageContents();
        },
        footer() {
            this.fitAllPageContents();
        },
    },
    methods: {
        onSelectConfiguration(id){
            this.configuration =  this.printConfigurations.find(conf => conf.id == id);
            this.pageInfo = this.configurationText;
        },
        onSelectSize(id){
            this.pageSize = id;
        },
        onSelectOrientation(id){
            this.pageOrientation = id;
        },
        onSelectStop(id){
            if (id && this.configuration) {
                this.loading = true;
                for (let timetable of this.$store.state.printEditor.stopTimetables) {
                    if (id == timetable.stop.id) {
                        // Already found.
                        return;
                    }
                }
                this.$store.dispatch('printEditor/getStopTimetable', { stopId: id, configurationId: this.configuration.id }) .finally(() => { 
                    this.stop = id;
                    this.loading = false;
                });

            }
        },
        print() {
            /*
            var style = document.createElement('style');
            style.type = 'text/css';            
            style.innerHTML = '@page { size: ' + this.pageOrientation + ' }';
            document.head.appendChild(style);
            window.print();
            */

            var printContent = document.getElementById("print-content").innerHTML;
            var printWindow = window.open('../static/traveller/html/print.html');
            const editor = this;
            printWindow.onload = function() {
                var doc = printWindow.document;

                var style = doc.createElement("style");
                style.innerHTML = editor.configurationStyle;
                doc.head.appendChild(style)

                style = doc.createElement("style");
                style.innerHTML = '@page { size: ' + editor.pageOrientation + ' }';
                doc.head.appendChild(style)

                doc.body.innerHTML = printContent;
            };

            printWindow.print();

        },
        removeStop(stopId) {
            var newStops = this.$store.state.printEditor.stopTimetables.filter(stopTimetable => stopTimetable.stop.id != stopId);
            this.$store.commit('printEditor/updateStopTimetables', newStops);
        },
        getPaddedHour(hour) {
            return (0 <= hour && hour < 5) ? String(hour).padStart(2, '0') : hour;
        },
        fitAllPageContents() {
            this.fitContents(this.$refs.headerContent, 14, 25);
            this.fitContents(this.$refs.stopTimetable, 18, 50);
        },
        headerLineRows(lines){
            //console.log("lines: " + lines.length);

            /*
            var rows = [];
            var cols = [];            

            var colCnt = 2;
            if(this.pageOrientation == 'landscape') colCnt = 3;
 
            for (let i = 0; i < lines.length; i++) {
                cols.push(lines[i]);
                if(cols.length >= colCnt || (i == lines.length - 1) ){
                    rows.push(cols);
                    cols = [];
                }
            }
            */
            var colCnt = 2;
            if(this.pageOrientation == 'landscape') colCnt = 3;
            var itemsPerCol = Math.ceil(lines.length / colCnt);
 
            var cols  = [];
            var colLines =  [];
            for (let i = 0; i < lines.length; i++) {
                colLines.push(lines[i]);
                if(colLines.length >= itemsPerCol || (i == lines.length - 1) ){
                    cols.push(colLines);
                    colLines = [];
                }
            }
            
            var rows = [];
            var rowData = [];
            for (let i = 0; i < itemsPerCol; i++) {
                rowData = [];
                for (let j = 0; j < colCnt; j++) {
                    let line = ""; 
                    let col = cols[j];
                    if(col && col[i]) line = col[i];
                    
                    //if(cols[j] && cols[j][i]) line = cols[j][i];
                    rowData.push(line);
                }
                rows.push(rowData);
            }

            return rows;
        },
        getElements(content){
            var elements = [];
            if (content) {
                if (Array.isArray(content)) {
                    for (let c of content) {
                        let container = c.parentNode;
                        elements.push( { "container": container, "content" : c} );
                    }
                } else {
                    let container = content.parentNode;
                    elements.push( { "container": container, "content": content } );
                }
            }

            return elements;
        },
        async fitContents(ref, initialFontSize, maxFontSize){
            // console.log("-- fitContents: " + ref);
            var elements = this.getElements(ref);
            for(let e of elements ){
                var contentId = e.content.dataset.id;
                var currentFontSize = parseInt(e.content.style.fontSize);
                this.dynamicFontSizes[contentId] = currentFontSize ? currentFontSize : initialFontSize;

                await this.$forceUpdate();

                var containerHeight = e.container.clientHeight;
                var contentHeight = e.content.clientHeight;
                var previousHeight;
                var noChangeCount = 0;
                
                //console.log(contentId + " : " + contentHeight+ "/" + containerHeight + " : " + this.dynamicFontSizes[contentId]);

                if (contentHeight >= containerHeight) {
                    while (contentHeight > containerHeight && noChangeCount < 5) {
                        previousHeight = contentHeight;

                        this.dynamicFontSizes[contentId]--;
                        
                        await this.$forceUpdate();
                     
                        contentHeight = e.content.clientHeight;
                        noChangeCount = contentHeight == previousHeight ? noChangeCount + 1 : 0;

                        //console.log(contentId + " : " + contentHeight+ "/" + containerHeight + " : " + this.dynamicFontSizes[contentId]);
                    }
                }
                else {
                    
                    while ( contentHeight < containerHeight && noChangeCount < 5 && this.dynamicFontSizes[contentId] < maxFontSize) {
                        previousHeight = contentHeight;
                       
                        this.dynamicFontSizes[contentId]++;

                        await this.$forceUpdate();
                       
                        contentHeight = e.content.clientHeight;
                        noChangeCount = contentHeight == previousHeight ? noChangeCount + 1 : 0;

                        //console.log(contentId + " : " + contentHeight+ "/" + containerHeight + " : "+ this.dynamicFontSizes[contentId]);
                    }

                    this.dynamicFontSizes[contentId]--;
                    await this.$forceUpdate();
                    contentHeight = e.content.clientHeight;

                    //console.log(contentId + " : " + contentHeight+ "/" + containerHeight + " : "+ this.dynamicFontSizes[contentId]);
                }
                
            }

        }
    },
    beforeCreate: function() {
        if (!this.$store.state.printEditor) {
             this.$store.registerModule("printEditor", printEditor);
        }
        this.$store.dispatch('printEditor/getConfigurationList').finally(() => { 
            //this.loading = false; 
            //console.log(this.printConfigurations.length);
            //this.configuration =  this.printConfigurations[0];
            this.configuration =  this.printConfigurations.find(conf => conf.id == "1");
        });

        this.$store.dispatch('printEditor/getStopList');
        this.$store.dispatch('printEditor/getLogoData');
    },
    mounted: function()  {
        this.fitAllPageContents();
    }
}
</script>
